import { GREY } from "./../puzzles/colors";
import { SVG } from "./svg";
const defaultOptions = {
    width: 500,
    height: 500,
    minx: -0.9,
    miny: -0.9,
    svgWidth: 1.8,
    svgHeight: 1.8,
    strokeWidth: 0.02,
    arrowColor: GREY,
    arrowStrokeWidth: 0.03,
};
/**
 * Creates PNG element
 */
export function PNG(container, type, options = {}) {
    if (typeof container === "string") {
        container = document.querySelector(container);
        if (container === null) {
            throw new Error(`Could not find visuzlier element by query selector: ${container}`);
        }
    }
    let element = document.createElement("div");
    options = Object.assign(Object.assign({}, defaultOptions), options);
    SVG(element, type, options);
    setTimeout(() => {
        let svgElement = element.querySelector("svg");
        let targetImage = document.createElement("img");
        container.appendChild(targetImage);
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        let loader = new Image();
        loader.width = canvas.width = targetImage.width = options.width;
        loader.height = canvas.height = targetImage.height = options.height;
        loader.onload = function () {
            ctx.drawImage(loader, 0, 0, loader.width, loader.height);
            targetImage.src = canvas.toDataURL();
        };
        var svgAsXML = new XMLSerializer().serializeToString(svgElement);
        loader.src = `data:image/svg+xml,${encodeURIComponent(svgAsXML)}`;
    });
}
